import fetchV2 from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";

const hubManagementService = {};

// List Hub
hubManagementService.listHub = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [];

  return fetchV2({
    url: `${env.API_MSP}/hubs`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker",
      fields: params.fields || defaultFields.join(","),
      parent_hub_name: params.parent_hub_name || undefined,
    },
  });
};

// Create Hub
hubManagementService.createHub = data => {
  return fetchV2({
    url: `${env.API_MSP}/hubs`,
    method: "post",
    data: {
      ...data,
    },
  });
};

// Detail Hub
hubManagementService.detailHub = ({
  hubId,
  params = { expand: undefined, fields: undefined },
}) => {
  return fetchV2({
    url: `${env.API_MSP}/hubs/${hubId}`,
    method: "get",
    params: {
      ...params,
      expand: params.expand || undefined,
      fields: params.fields || undefined,
    },
  });
};

// Update Hub
hubManagementService.updateHub = ({ hubId = undefined, data = {} }) => {
  return fetchV2({
    url: `${env.API_MSP}/hubs/${hubId}`,
    method: "put",
    data: {
      ...data,
    },
  });
};

export default hubManagementService;
